export default __webpack_public_path__ + "static/chat-icon-50c83f95269065a4f1b8bdecdca19d0f.svg";